export const getUserDetailsById = `query getUserDetail($id: String!) {
  userDetail(Id: $id) {
    id
    lastLogin
    username
    firstName
    lastName
    isActive
    dateJoined
    dateOfJoining
    email    
    dateOfBirth
    contactNumber
    emergencyContact
    gender        
    department
    designation
    empid        
    aadharNumber
    panNumber    
    secondaryContactNumber
    officialMail
    address    
    city
    country
    zipCode
    state
    maritalStatus         
    uanNumber
    esicNumber
    fathersName
    bankDetails {
      bankName
      accountNumber
      branchName
      ifscNumber
      cifNumber
    }
  }
}
`;

export const updateProfileQuery =  `
mutation EditProfile($input: ProfileEditInput!) {
  editProfile(input: $input) {
    success
    message
    data {
      id
      empid
      firstName
      lastName
      fathersName
      maritalStatus
      address
      country
      state
      city
      zipCode
      gender
      dateOfBirth
      contactNumber
      emergencyContact
      secondaryContactNumber
      aadharNumber
      panNumber
    }
  }
}`